const ArrowRightIcon = () => {
  return (
    <svg
      style={{ marginLeft: "auto" }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21043 11.84C5.94772 11.6113 5.92836 11.2221 6.16719 10.9707L8.98835 8L6.16719 5.02934C5.92836 4.77786 5.94772 4.38866 6.21043 4.16004C6.47314 3.93142 6.87971 3.94995 7.11854 4.20144L10.3328 7.58605C10.5557 7.82077 10.5557 8.17923 10.3328 8.41395L7.11854 11.7986C6.87971 12.05 6.47314 12.0686 6.21043 11.84Z"
        fill="#00263A"
        fillOpacity="0.32"
      />
    </svg>
  )
}


export default ArrowRightIcon